import React from "react";
import Rating from "@material-ui/lab/Rating";
// import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

export default function SimpleGetRating(props) {
  let [value, setValue] = React.useState();
  let rating = props.rating;
  value = rating;
  var opts = {};
  if (props.readOnly === "readOnly") {
    opts["readOnly"] = true;
  }
  return (
    <div>
      <Box component="fieldset" mb={3} borderColor="transparent">
        <Rating
          name="simple-controlled"
          value={value}
          onChange={(newValue) => {
            setValue(newValue);
          }}
          {...opts}
        />
      </Box>
    </div>
  );
}
